/*
 * Brimworth benefit info popovers (product page "Benefits row").
 * A click on a benefit box opens a small explanation popover below the
 * row; a second click, a click elsewhere or Escape closes it. Only one
 * popover is open at a time. The popover is clamped inside the row so
 * it never falls off-screen; its arrow points at the clicked box.
 */
(function () {
  if (window.brimworthBenefitsInit) return;
  window.brimworthBenefitsInit = true;

  let openTrigger = null;

  function popoverFor(trigger) {
    return document.getElementById(trigger.getAttribute('aria-controls'));
  }

  function position(trigger) {
    const popover = popoverFor(trigger);
    const row = trigger.closest('.brimworth-benefits');
    if (!popover || !row) return;

    const rowRect = row.getBoundingClientRect();
    const boxRect = trigger.getBoundingClientRect();
    const width = popover.offsetWidth;
    const boxCenter = boxRect.left + boxRect.width / 2 - rowRect.left;

    let left = boxCenter - width / 2;
    left = Math.max(0, Math.min(left, rowRect.width - width));

    const arrowInset = 16;
    const arrowX = Math.max(arrowInset, Math.min(boxCenter - left, width - arrowInset));

    popover.style.left = left + 'px';
    popover.style.setProperty('--bw-arrow-x', arrowX + 'px');
  }

  function open(trigger) {
    if (openTrigger && openTrigger !== trigger) close(openTrigger);
    position(trigger);
    trigger.setAttribute('aria-expanded', 'true');
    popoverFor(trigger)?.classList.add('is-open');
    openTrigger = trigger;
  }

  function close(trigger, returnFocus) {
    trigger.setAttribute('aria-expanded', 'false');
    popoverFor(trigger)?.classList.remove('is-open');
    if (openTrigger === trigger) openTrigger = null;
    if (returnFocus) trigger.focus();
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.brimworth-benefits__trigger');
    if (trigger) {
      trigger.getAttribute('aria-expanded') === 'true' ? close(trigger) : open(trigger);
      return;
    }
    if (!openTrigger) return;
    // Clicks inside the open popover (e.g. selecting text) keep it open.
    if (event.target.closest('.brimworth-benefits__popover.is-open')) return;
    close(openTrigger);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openTrigger) close(openTrigger, true);
  });

  // Keyboard: close when focus moves away from the open benefit.
  document.addEventListener('focusin', function (event) {
    if (openTrigger && !openTrigger.parentElement.contains(event.target)) close(openTrigger);
  });

  window.addEventListener('resize', function () {
    if (openTrigger) position(openTrigger);
  });
})();
